var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcnAnagrafiche = function SvgIcnAnagrafiche(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.022 19.084",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(-16.003 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(28.895 80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M258.249,89.542a4.154,4.154,0,0,1-3.034-1.4,5.418,5.418,0,0,1-1.409-3.309,4.525,4.525,0,0,1,1.145-3.456,4.623,4.623,0,0,1,6.589.009,4.512,4.512,0,0,1,1.152,3.449,5.429,5.429,0,0,1-1.41,3.307A4.152,4.152,0,0,1,258.249,89.542Zm0-7.807a2.723,2.723,0,0,0-2.029.823,2.775,2.775,0,0,0-.684,2.151,3.679,3.679,0,0,0,.948,2.249,2.258,2.258,0,0,0,3.528,0,3.689,3.689,0,0,0,.95-2.25h0a2.8,2.8,0,0,0-.692-2.142A2.714,2.714,0,0,0,258.249,81.735Z",
    transform: "translate(-253.792 -80)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(24.678 91.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M191.839,295.807H177.545a1.5,1.5,0,0,1-1.192-.579,1.639,1.639,0,0,1-.285-1.4,7.145,7.145,0,0,1,3.27-4.4,10.774,10.774,0,0,1,10.705-.022,7.105,7.105,0,0,1,3.274,4.421,1.643,1.643,0,0,1-.288,1.4A1.5,1.5,0,0,1,191.839,295.807Zm-14.04-1.735h13.787a5.413,5.413,0,0,0-2.451-3.182,9.048,9.048,0,0,0-8.883.019A5.459,5.459,0,0,0,177.8,294.072Z",
    transform: "translate(-176.018 -288)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(19.355 81.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M81.585,120.024a4.074,4.074,0,0,1-3.739-3.954,3.808,3.808,0,0,1,.972-2.907,3.858,3.858,0,0,1,5.528.007,3.8,3.8,0,0,1,.977,2.9h0A4.077,4.077,0,0,1,81.585,120.024Zm0-6.289a2.011,2.011,0,0,0-1.5.611,2.067,2.067,0,0,0-.511,1.6,2.032,2.032,0,1,0,4.016,0h0a2.084,2.084,0,0,0-.517-1.595A2,2,0,0,0,81.585,113.735Z",
    transform: "translate(-77.836 -112)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(16.003 90.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M23.484,285.134H17.4a1.373,1.373,0,0,1-1.089-.528,1.487,1.487,0,0,1-.261-1.266,5.881,5.881,0,0,1,2.691-3.618A8.385,8.385,0,0,1,23.1,278.55a8.4,8.4,0,0,1,3.56.7.867.867,0,1,1-.723,1.577,6.711,6.711,0,0,0-2.837-.542,6.632,6.632,0,0,0-3.453.912,4.216,4.216,0,0,0-1.814,2.2h5.647a.867.867,0,1,1,0,1.735Z",
    transform: "translate(-16.003 -278.55)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAnagrafiche, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_anagrafiche.92534a21.svg";
export { ForwardRef as ReactComponent };